/*
 * spurtcommerce
 * version 4.3
 * www.spurtcommerce.com
 *
 * Copyright (c) 2020 piccosoft ltd
 * Author piccosoft ltd <support@piccosoft.com>
 * Licensed under the MIT license.
 */
import { Component, OnInit, PLATFORM_ID, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';

import { isPlatformBrowser } from '@angular/common';
import { ListsSandbox } from '../../../core/lists/lists.sandbox';
import { ListsService } from '../../../core/lists/lists.service';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { ConfigService } from 'src/core/service/config.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {
  public imageUrl: any;
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  public BrandList: any = [];
  customerReviews = [
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Multisystem%20Electronics%20updated/TVS%20LED%20LCD%20and%20Plasma%20And%20Multisystem/Samsung%20UA-82NU8000/&name=UA-82NU8000%201.jpg&width=150&height=150',
      productName: 'Samsung UA-82NU8000 82 Inch CURVED SMART Multisystem LED TV with One Billion Color, One Master Remote Control: 110-240 Volt, 50/60 Hz',
      reviewDate: '15 Mar 2023',
      review: "This product exceeded my expectations. I'm very happy with my purchase.",
      rating: 5,
      userName: 'HappyBuyer1',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Countertop%20Appliances/Stand%20Mixer%20(commercial)/EWI%20EXGEM130-INT/EXGEM130/&name=EXGEM130-1.jpg&width=150&height=150',
      productName: 'EWI EXGEM130-INT 1Ph Commercial Stand Mixer With 30 Quarts Bowl Capacity, 2 Horse Power, Speed 91/166/282 R/MIN450Lb: Stainless steel, 220-240V 50HZ',
      reviewDate: '23 Jan 2023',
      review: 'I wish I could give it 6 stars! Absolutely fantastic product.',
      rating: 5,
      userName: 'SatisfiedShopper2',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Other%20220%20Volt%20Products/Clock%20Radios%20Alarm%20Clock/AJ3122/&name=AJ3122_1.jpg&width=150&height=150',
      productName: 'Philips AJ3122 Clock Radio Alarm Clock With FM Antenna, Easy alarm/time set, Clock/Version: Digital: Black/White, 220-240V 50HZ',
      reviewDate: '04 Apr 2023',
      review: "It's an average product. Nothing special but gets the job done.",
      rating: 3,
      userName: 'OkayUser3',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Other%20220%20Volt%20Products/Vacuum%20Cleaners%20And%20Shampoo%20Polishers/ZE090/&name=ZE090_1.jpg&width=150&height=150',
      productName: 'Z-Electrolux ZE090 Belt for Electrolux Upright Vacuum Z2250,Z8800AZ & Z2961AZ',
      reviewDate: '21 Apr 2023',
      review: "Not impressed. I expected better quality for the price.",
      rating: 2,
      userName: 'DisappointedBuyer4',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Office%20Products%20updated/Projection%20Screens/Epson%20Duet/&name=Epson%20Duet_1.jpg&width=150&height=150',
      productName: 'Epson Duet 65 Inch Standard Tripod Projection Screen, 80 inch Widescreen: White, 220-240V 50HZ',
      reviewDate: '10 Oct 2023',
      review: "I love this product! It's a game-changer for me.",
      rating: 5,
      userName: 'ProductLover5',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Multisystem%20Electronics%20updated/Stereo%20and%20Home%20Theatre%20Systems/Toshiba%20TX-CRM10D/&name=Toshiba%20TX-CRM10D%201.jpg&width=150&height=150',
      productName: 'Toshiba TX-CRM10D Boom Box, CD Radio Player, CD-R/ RW Playback, AM/FM Band, Stereo Speaker: Black & White, 110-240 Volt, 50/60 Hz',
      reviewDate: '19 Jan 2023',
      review: 'Great value for the money. I highly recommend it.',
      rating: 4,
      userName: 'RecommendUser6',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/220%20Volt%20Appliances%20(Overseas%20use%20only)/Cook%20Tops/Cooktop%20AEG/AEG%20HK955070XB/&name=HK955070XB_1.jpg&width=150&height=150',
      productName: 'AEG HK955070XB 35.43 Inch Electric Cooktop with Ceramic Glass, 7900 Watts Power, Extra-wide hob cooking zones, CountUp timer, Child safety lock function, and CE Approvals: Black',
      reviewDate: '04 May 2023',
      review: 'Terrible product. Avoid at all costs!',
      rating: 1,
      userName: 'RegretfulBuyer7',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/220%20Volt%20Appliances%20(Overseas%20use%20only)/Air%20Conditioners/Air%20Conditioner%20Multistar/Multistar%20MSP12HCPR/&name=MSP12HCPR_1.jpg&width=150&height=150',
      productName: 'Multistar® MSP12HCPR 1Ph Portable Air Conditioner With 12,000 Btu Cool/ Heat-Pump, Environmentally Friendly R410 Refrigerant, Remote Control: Black/ White, 220-240V 50HZ ',
      reviewDate: '21 Dec 2022',
      review: "It's not bad, but it's not great either. Just okay.",
      rating: 3,
      userName: 'NeutralReviewer8',
    },
    {
      productImage: 'http://157.230.179.86:3000/api/media/image-resize?path=Product/Images/Power%20tools/Drills%20Drivers/Drills%20Impact%20Hammer%20Products/Bosch%20GBH540D/&name=GBH540D%20%201.png&width=150&height=150',
      productName: 'Bosch GBH540D Professional Rotary Hammer with SDS Max, 8.5 Joules Impact Energy, 1100 Watts Power, 1500-2900 bpm, 170- 340 rpm Rated speed, 12 different chisel positions with Vario-lock, Auxiliary Handle: 220V/240V',
      reviewDate: '21 Sep 2023',
      review: "I'm very disappointed with this product. Not worth the price.",
      rating: 2,
      userName: 'UnsatisfiedShopper9',
    },
  ];
  storename = environment.storename;
  settingsId = environment.settingsId;
  public home :any;
  public config: SwiperConfigInterface = {
    
  }
//   private pagination: SwiperPaginationInterface = {
//     el: '.swiper-pagination',
//     clickable: true
// };

  Allreviews: any;
  imagePath: any;

  constructor(
    public listSandbox: ListsSandbox, private listService: ListsService, private router: Router,public http:HttpClient,private configService: ConfigService,
    @Inject(PLATFORM_ID) private platformId: Object) {
      this.imagePath = this.configService.getImageUrl();
      this.http.get(`http://157.230.179.86:3000/api/product/product-rating-list?limit=100&offset=0&productId=&count=false&selected=3&featured=1`).subscribe((res:any)=>{
        console.log("valuess",res.data)
        this.Allreviews = res.data;
        //  to use first 15 product res.data.slice(0, 15)    
  
      })
  }
  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    clickable: true
};
public reviewConfig: SwiperConfigInterface = {
    
}
  // Initially calls getBannerList,getBransList,getFeaturedList
  ngOnInit() {
  this.ngAfterViewInit()
    this.imageUrl = environment.imageUrl;
    this.storename = environment.storename;
    // this.getBannerList();
    this.getFeaturedList();
    this.getBransList();
    this.getTodayDealList();
    this.BodySection(this.storename);
    this.BrandFunction(this.storename);
    this.getSettings();
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem('checkout');
    }
  }
  // function calls at finally
  ngAfterViewInit() {
    this.config = {
      slidesPerView: 7,
      spaceBetween: 16,
      keyboard: true,
      navigation: true,
      pagination: true,
      grabCursor: true,
      loop: true,
      preloadImages: false,
      lazy: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      speed: 500,
      effect: 'slide',
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 3
        },
        960: {
          slidesPerView: 4
        },
        1280: {
          slidesPerView: 5
        },
        1500: {
          slidesPerView: 6
        }
      }
    };
    this.reviewConfig = {
      slidesPerView: 3,
      spaceBetween: 10,
      keyboard: true,
      navigation: false,
      pagination: this.pagination,
      grabCursor: true,
      loop: true,
      preloadImages: true,
      lazy: false,
      autoplay: false,
      speed: 500,
      effect: 'slide',
      breakpoints: {
        320: {
          slidesPerView: 1
        },
        480: {
          slidesPerView: 2
        },
        600: {
          slidesPerView: 2
        },
        960: {
          slidesPerView: 3
        },
        1280: {
          slidesPerView: 3
        },
        1500: {
          slidesPerView: 3
        }
      }
    }
  }
  // fetch banner list from sandbox
  // getBannerList() {
  //     const params: any = {};
  //     params.limit = 100;
  //     params.offset = 0;
  //     this.listSandbox.getBannerList(params);
  // }
  // fetch brand list from sandbox
  slideToIndex(index: number) {
    console.log(index)
    // this.swiper.directiveRef.setIndex(index);
    
  }
  getBransList() {
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.selected = '';
    this.listSandbox.getManufacturerList(params);
  }
  // fetch featured product list from sandbox

  public getFeaturedList() {
    const params: any = {};
    params.limit = '';
    params.offset = 0;
    params.keyword = '';
    params.sku = '';
    this.listSandbox.getFeaturedList(params);
  }
  // fetch getTodayDealList product list from sandbox
  public getTodayDealList() {
    const params: any = {};
    params.limit = 0;
    params.offset = 0;
    params.keyword = '';
    params.sku = '';
    // params.count = '';
    this.listSandbox.getTodayDealList(params);
  }

  // Body Section
  BodySection(i) {
    const params = {
      storeName: i
    };
    this.listService.getHomeList(params).subscribe((res: any) => {
      console.log('Home-->', res.data)
      this.home = res.data;
    });
  }

  // Brand
  BrandFunction(i) {
    // const params: any = {};
    // params.limit = '';
    // params.keyword = '';
    // params.selected = '';
    // params.status = 1;
    // this.listService.getManufacturer(params).subscribe((res: any) => {
    //   // console.log('brand-->', res.data)
    //   if (environment.storename === 'East West') {
    //     const arr = res.data.slice(0, 7);
    //     this.BrandList = arr;
    //   } else {
    //     const arr = res.data.slice(0, 14);
    //     this.BrandList = arr;
    //   }

    // });
    const data = {
      storename: i
    };
    this.listService.getFooterList(data).subscribe((res: any) => {
      console.log('Footer-->', res.data)
      this.BrandList = res.data.brand;
      // this.Footers = res.data;
      // for (let i = 0; i < 7; i++) {
      //   this.Brands.push(res.data.brand[i]);
      // }
      // // this.Brands = res.data.brand
      // this.Category = res.data.category;
      // this.Information = res.data.informationPage;
    });
  }

  // Get Settings
  getSettings() {
    this.listService.getsettings().subscribe((res: any) => {
      // console.log('Setttings-->',res)
    });
  }

  // go to products
  gotofilter(i) {
    this.router.navigate(['/products'], { queryParams: { 'brand': i } });
  }
}
